import { Component, HostListener, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IPopupData } from '../../interfaces/popup-data.interface';

@Component({
    selector: 'aumico-information-popup',
    templateUrl: 'editable-information-popup.component.html',
    styleUrls: ['editable-information-popup.component.scss'],
})
export class AumicoEditableInformationPopupComponent {
    contentMessage: string | undefined;
    titleLocalizationKey = 'aumico_core_information_popup_default_title';
    content = new FormControl();

    constructor(
        private dialogRef: MatDialogRef<AumicoEditableInformationPopupComponent, void>,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) private popupData: IPopupData,
    ) {
        if (this.popupData.contentMessage != null) {
            this.contentMessage = this.popupData.contentMessage;
            this.content.setValue(this.contentMessage);
        }

        if (this.popupData.titleLocalizationKey != null) {
            this.titleLocalizationKey = this.popupData.titleLocalizationKey;
        }

        this.addSvgIcons();
    }

    @HostListener('document:keyup.enter', ['$event'])
    onKeyUp(event: KeyboardEvent) {
        this.closeDialog();
    }

    closeDialog(saveToRichText?: boolean): void {
        const result = {
            information: this.content.value,
            saveToRichText,
        } as unknown as any;
        this.dialogRef.close(result);
    }

    onAddNoteText(): void {
        this.closeDialog(true);
    }

    private addSvgIcons(): void {
        this.matIconRegistry
            .addSvgIcon(
                'interface-delete 1',
                this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/interface-delete 1.svg'),
            )
            .addSvgIcon(
                'aumico_add_icon_black',
                this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/aumico_add_icon_black.svg'),
            );
    }
}
